export const formatHelpCenterUrl = (id: string, title: string) => {
	return (
		id +
		"-" +
		title
			.toLowerCase()
			.replace(/[^a-z0-9 -]/gi, "")
			.replace(/\s+/g, "-")
	);
};

export const getIdFromUrl = (id: string) => {
	return id.split("-")[0];
};
